import React, { useEffect, useState } from "react";
import "./styles/dashboard.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CommonHeader from "./components/CommonHeader";

const FollowUpStatus = () => {
  const navigate = useNavigate();

  const [followUpStatuses, setFollowUpStatuses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    follow_up_status_name: '',
    notify_whatsapp: '',
    status: ''
  });

  // Form state for add/edit
  const [formData, setFormData] = useState({
    follow_up_status_id: '',
    follow_up_status_name: '',
    follow_up_status_color_code: '#000000',
    notify_whatsapp: '0',
    status: '1'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      follow_up_status_id: '',
      follow_up_status_name: '',
      follow_up_status_color_code: '#000000',
      notify_whatsapp: '0',
      status: '1'
    });
  };

  const handleAddFollowUpStatus = () => {
    if (!formData.follow_up_status_name.trim()) {
      toast.error('Follow-up status name is required');
      return;
    }

    setLoading(true);
    const data = new URLSearchParams();
    data.append('follow_up_status_name', formData.follow_up_status_name);
    data.append('follow_up_status_color_code', formData.follow_up_status_color_code);
    data.append('notify_whatsapp', formData.notify_whatsapp);
    data.append('status', formData.status);

    fetch(`${process.env.REACT_APP_API_URL}/FollowUpStatus/addFollowUpStatus`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.status === 1) {
        toast.success("Follow-up status saved successfully");
        setShowAddModal(false);
        resetForm();
        fetchFollowUpStatuses();
      } else {
        toast.error(resp.message || 'Failed to save follow-up status');
      }
      setLoading(false);
    }).catch(error => {
      console.error('Error saving follow-up status:', error);
      toast.error('Failed to save follow-up status');
      setLoading(false);
    });
  };

  const handleEditFollowUpStatus = () => {
    if (!formData.follow_up_status_name.trim()) {
      toast.error('Follow-up status name is required');
      return;
    }

    setLoading(true);
    const data = new URLSearchParams();
    data.append('follow_up_status_id', formData.follow_up_status_id);
    data.append('follow_up_status_name', formData.follow_up_status_name);
    data.append('follow_up_status_color_code', formData.follow_up_status_color_code);
    data.append('notify_whatsapp', formData.notify_whatsapp);
    data.append('status', formData.status);

    fetch(`${process.env.REACT_APP_API_URL}/FollowUpStatus/addFollowUpStatus`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.status === 1) {
        toast.success("Follow-up status updated successfully");
        setShowEditModal(false);
        resetForm();
        fetchFollowUpStatuses();
      } else {
        toast.error(resp.message || 'Failed to update follow-up status');
      }
      setLoading(false);
    }).catch(error => {
      console.error('Error updating follow-up status:', error);
      toast.error('Failed to update follow-up status');
      setLoading(false);
    });
  };

  const handleDeleteFollowUpStatus = (statusId, statusName) => {
    if (window.confirm(`Are you sure you want to delete follow-up status "${statusName}"?`) === false) {
      return false;
    }

    const data = new URLSearchParams();
    data.append('follow_up_status_id', statusId);
    
    fetch(`${process.env.REACT_APP_API_URL}/FollowUpStatus/deleteFollowUpStatus`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.status === 1) {
        toast.success("Follow-up status deleted successfully");
        fetchFollowUpStatuses();
      } else {
        toast.error(resp.message || 'Failed to delete follow-up status');
      }
    }).catch(error => {
      console.error('Error deleting follow-up status:', error);
      toast.error('Failed to delete follow-up status');
    });
  };

  const handleEditClick = (status) => {
    setFormData({
      follow_up_status_id: status.follow_up_status_id,
      follow_up_status_name: status.follow_up_status_name,
      follow_up_status_color_code: status.follow_up_status_color_code || '#000000',
      notify_whatsapp: status.notify_whatsapp || '0',
      status: status.status || '1'
    });
    setShowEditModal(true);
  };

  const fetchFollowUpStatuses = () => {
    setLoading(true);
    const data = new URLSearchParams();
    if (filters.follow_up_status_name) data.append('follow_up_status_name', filters.follow_up_status_name);
    if (filters.notify_whatsapp) data.append('notify_whatsapp', filters.notify_whatsapp);
    if (filters.status) data.append('status', filters.status);

    fetch(`${process.env.REACT_APP_API_URL}/FollowUpStatus/getFollowUpStatusList`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.status === 1) {
        setFollowUpStatuses(resp.list || []);
      } else {
        toast.error(resp.message || 'Failed to fetch follow-up statuses');
        setFollowUpStatuses([]);
      }
      setLoading(false);
    }).catch(error => {
      console.error('Error fetching follow-up statuses:', error);
      toast.error('Failed to fetch follow-up statuses');
      setFollowUpStatuses([]);
      setLoading(false);
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchFollowUpStatuses();
  };

  const clearFilters = () => {
    setFilters({
      follow_up_status_name: '',
      notify_whatsapp: '',
      status: ''
    });
  };

  useEffect(() => {
    fetchFollowUpStatuses();
  }, []);

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />

          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div class="card shadow border-0 mb-7">
                <div class="card-header">
                  <h5 class="mb-0">Follow-up Statuses</h5>
                </div>

                {/* Filters */}
                <div class="card-body border-bottom">
                  <form onSubmit={handleFilterSubmit} class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label">Status Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="follow_up_status_name"
                        value={filters.follow_up_status_name}
                        onChange={handleFilterChange}
                        placeholder="Search by status name..."
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">WhatsApp Notification</label>
                      <select
                        class="form-select"
                        name="notify_whatsapp"
                        value={filters.notify_whatsapp}
                        onChange={handleFilterChange}
                      >
                        <option value="">All</option>
                        <option value="1">Enabled</option>
                        <option value="0">Disabled</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Status</label>
                      <select
                        class="form-select"
                        name="status"
                        value={filters.status}
                        onChange={handleFilterChange}
                      >
                        <option value="">All Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                    <div class="col-md-3 d-flex align-items-end">
                      <button type="submit" class="btn btn-primary me-2">
                        <i class="bi bi-search me-1"></i>
                        Search
                      </button>
                      <button type="button" class="btn btn-outline-secondary" onClick={clearFilters}>
                        Clear
                      </button>
                    </div>
                  </form>
                </div>

                <div class="table-responsive">
                  <table class="table table-hover table-nowrap">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">Status Name</th>
                        <th scope="col">Color</th>
                        <th scope="col">WhatsApp Notification</th>
                        <th scope="col">Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colspan="5" class="text-center">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      ) : followUpStatuses.length > 0 ? (
                        followUpStatuses.map((status) => (
                          <tr key={status.follow_up_status_id}>
                            <td>{status.follow_up_status_name}</td>
                            <td>
                              {status.follow_up_status_color_code && (
                                <div class="d-flex align-items-center">
                                  <div 
                                    class="color-preview me-2" 
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      backgroundColor: status.follow_up_status_color_code,
                                      border: '1px solid #ddd',
                                      borderRadius: '3px'
                                    }}
                                  ></div>
                                  <span class="text-muted">{status.follow_up_status_color_code}</span>
                                </div>
                              )}
                            </td>
                            <td>
                              <span class="badge badge-lg badge-dot">
                                {status.notify_whatsapp === '1' ? (
                                  <>
                                    <i className="bg-success"></i>
                                    {'Enabled'}
                                  </>
                                ) : (
                                  <>
                                    <i style={{ backgroundColor: "gray" }}></i>
                                    {'Disabled'}
                                  </>
                                )}
                              </span>
                            </td>
                            <td>
                              <span class="badge badge-lg badge-dot">
                                {status.status === '1' ? (
                                  <>
                                    <i className="bg-success"></i>
                                    {'Active'}
                                  </>
                                ) : (
                                  <>
                                    <i style={{ backgroundColor: "gray" }}></i>
                                    {'Inactive'}
                                  </>
                                )}
                              </span>
                            </td>
                            <td class="text-end">
                              <button
                                onClick={() => handleEditClick(status)}
                                class="btn btn-sm btn-neutral"
                                style={{ marginRight: "0.5rem" }}
                              >
                                Edit
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-square btn-neutral text-danger-hover"
                                onClick={() => handleDeleteFollowUpStatus(status.follow_up_status_id, status.follow_up_status_name)}
                                title="Delete Follow-up Status"
                              >
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colspan="5" class="text-center text-muted">
                            No follow-up statuses found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div class="card-footer border-0 py-5">
                  <button
                    class="btn d-inline-flex btn-sm btn-primary mx-1"
                    onClick={() => setShowAddModal(true)}
                  >
                    <span class="pe-2">
                      <i class="bi bi-plus"></i>
                    </span>
                    <span>Add Follow-up Status</span>
                  </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Add Follow-up Status Modal */}
      {showAddModal && (
        <div class="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add New Follow-up Status</h5>
                <button 
                  type="button" 
                  class="btn-close" 
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="mb-3">
                    <label class="form-label">Status Name *</label>
                    <input
                      type="text"
                      class="form-control"
                      name="follow_up_status_name"
                      value={formData.follow_up_status_name}
                      onChange={handleInputChange}
                      placeholder="Enter status name"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Color Code</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="color"
                        class="form-control form-control-color me-2"
                        name="follow_up_status_color_code"
                        value={formData.follow_up_status_color_code}
                        onChange={handleInputChange}
                        style={{ width: '60px', height: '38px' }}
                      />
                      <input
                        type="text"
                        class="form-control"
                        name="follow_up_status_color_code"
                        value={formData.follow_up_status_color_code}
                        onChange={handleInputChange}
                        placeholder="#000000"
                      />
                    </div>
                    <small class="text-muted">Choose a color or enter hex code</small>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">WhatsApp Notification</label>
                    <select
                      class="form-select"
                      name="notify_whatsapp"
                      value={formData.notify_whatsapp}
                      onChange={handleInputChange}
                    >
                      <option value="0">Disabled</option>
                      <option value="1">Enabled</option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Status</label>
                    <select
                      class="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  onClick={handleAddFollowUpStatus}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      Saving...
                    </>
                  ) : (
                    'Save Status'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Follow-up Status Modal */}
      {showEditModal && (
        <div class="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Follow-up Status</h5>
                <button 
                  type="button" 
                  class="btn-close" 
                  onClick={() => {
                    setShowEditModal(false);
                    resetForm();
                  }}
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="mb-3">
                    <label class="form-label">Status Name *</label>
                    <input
                      type="text"
                      class="form-control"
                      name="follow_up_status_name"
                      value={formData.follow_up_status_name}
                      onChange={handleInputChange}
                      placeholder="Enter status name"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Color Code</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="color"
                        class="form-control form-control-color me-2"
                        name="follow_up_status_color_code"
                        value={formData.follow_up_status_color_code}
                        onChange={handleInputChange}
                        style={{ width: '60px', height: '38px' }}
                      />
                      <input
                        type="text"
                        class="form-control"
                        name="follow_up_status_color_code"
                        value={formData.follow_up_status_color_code}
                        onChange={handleInputChange}
                        placeholder="#000000"
                      />
                    </div>
                    <small class="text-muted">Choose a color or enter hex code</small>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">WhatsApp Notification</label>
                    <select
                      class="form-select"
                      name="notify_whatsapp"
                      value={formData.notify_whatsapp}
                      onChange={handleInputChange}
                    >
                      <option value="0">Disabled</option>
                      <option value="1">Enabled</option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Status</label>
                    <select
                      class="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  onClick={() => {
                    setShowEditModal(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  onClick={handleEditFollowUpStatus}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      Updating...
                    </>
                  ) : (
                    'Update Status'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FollowUpStatus; 